import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CallHandler, CustomerDetail, CallTag } from './components';
import { globalStateSelector } from 'store/selector';
import DTMF from './DTMF';
import CallInfo from './CallInfo';
import AddCall from './AddCall';
import AddNewCall from './AddNewCall';


export class CallScreen extends Component {
  constructor(props) {
    super(props);
    this.renderHandler = this.renderHandler.bind(this);
  }
  renderHandler() {
    const { userState, callTab } = this.props
    let state = userState && userState.State ? userState.State : '';
    if (callTab == "DTMF") {
      return <DTMF />;
    } else if (callTab == "TRANSFER_LIST") {
      return <AddCall />;
    } else if (callTab == "TRANSFER_AGENT") {
      return <AddNewCall />;
    } else if (callTab == "INFO") {
      return <CallInfo />;
    } else if (callTab == "ACW" || state == "ACW") {
      return <CallTag isBack={state == "ACW" ? false : true} />;
    } else {
      return <CallHandler />;
    }
  }
  render() {
    const { userState } = this.props
    let state = userState && userState.State ? userState.State : '';
    return (
      <div style={{ width: '100%', padding: 20, height: 360 }}>
        {this.renderHandler()}
      </div>
    );
  }
}
CallScreen.contextTypes = {
  __: PropTypes.func
};
const stateToProps = state => ({
  userState: globalStateSelector.getState(state),
  onCall: globalStateSelector.getOnCall(state),
  callTab: globalStateSelector.getDynamic(state, { key: 'callTab' })
});

const dispatchToProps = dispatch => ({
  receiveSocketMessage: data => {
    // console.log(`receiveSocketMessage --> `, data);
    // dispatch(messageAction.receiveSocketMessage(data));
  }
});
export default connect(stateToProps, dispatchToProps)(CallScreen);



// WEBPACK FOOTER //
// src/dialpad/components/layout/CallScreen.js